import { z } from "zod";
export const ElementPropertyTypeSchema = z.enum([
    "Text",
    "Number",
    "Boolean",
    "Select",
    "Generic",
    "Link",
    "URL",
]);
export const ElementPropertyTargetType = z.enum([
    "Token",
    "Component",
    "DocumentationPage",
]);
export const ElementPropertyLinkType = z.enum([
    "FigmaComponent",
    "DocumentationPage",
]);
export const ElementPropertyImmutableType = z.enum(["Collection"]);
const CODE_NAME_REGEX = /^[a-zA-Z_$][a-zA-Z_$0-9]{1,99}$/;
export const ColorTokenInlineData = z.object({
    value: z.string(),
});
export const ElementPropertyDefinitionOption = z.object({
    id: z.string(),
    name: z.string(),
    backgroundColor: ColorTokenInlineData.optional(),
});
export const ElementPropertyDefinition = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    persistentId: z.string(),
    name: z.string(),
    codeName: z.string().regex(CODE_NAME_REGEX),
    description: z.string(),
    type: ElementPropertyTypeSchema,
    targetElementType: ElementPropertyTargetType,
    options: z.array(ElementPropertyDefinitionOption).optional(),
    linkElementType: ElementPropertyLinkType.optional(),
});
export const ElementPropertyType = ElementPropertyTypeSchema.enum;
